class GoogleAutocomplete {
    /**
     * Constructor
     */
    constructor() {
        /**
         * @type {string}
         */
        this.API_KEY = 'AIzaSyADSC7lKWf8FmgDbetvGM2SOvGHJV0M_AY';
        /**
         * @type {string}
         */
        this.SCRIPT_SRC = '//maps.googleapis.com/maps/api/js?key=' + this.API_KEY + '&libraries=places&language=fr';
        /**
         * Init
         */
        Helper.loadScript(this.SCRIPT_SRC).then(() => this.init());
    }

    /**
     * Init
     */
    init() {

        const INPUT   = document.getElementsByClassName('autocompleteCity');
        const OPTIONS = {

            types                 : ["(regions)"],
            components            : {country: "fr"},
            componentRestrictions : {country: "fr"},

        };

        for (let i = 0; i < INPUT.length; i++) {

           new google.maps.places.Autocomplete(INPUT[i], OPTIONS);
        }

    }
}
